import type { AppRouterClient } from "../../../server/src/routers/index";
import { RPCLink } from "@orpc/client/fetch";
import { createORPCClient } from "@orpc/client";

const link = new RPCLink({
  url: `${import.meta.env.VITE_SERVER_URL}/rpc`,
  // headers: () => {
  //   const token = localStorage.getItem("jwtToken");
  //   return {
  //     ...(token && { Authorization: `Bearer ${token}` }),
  //   };
  // },
  fetch: (input, init) => {
    return fetch(input, {
      ...init,
      credentials: "include",
    });
  },
});

export const orpcClient: AppRouterClient = createORPCClient(link);
